import { useTranslation } from "react-i18next";
import {
	FrontendUserInfo,
	FrontendOrder,
	FrontendProductOrder,
	FrontendOrderItem,
} from "node-library/dist/portal";

import { UserType } from "node-library/dist/constants";
import {
	getAdminStatusColors,
	getAdminStatusString,
} from "../../../helpers/orderHelper";
import { NeutralColor, SemanticColor } from "node-library/dist/colors";
import { DeleteIcon, UserIcon } from "../../../common-components/svgIcons";
import { formatCustomDate } from "node-library/dist/helpers/date_helper";
import { roleMeetsRequirement } from "node-library/dist/helpers/request_helper";
import Restricted from "../../../permissionProvider/Restricted";
import { Permission } from "../../../permissionProvider/PermissionProvider";
import {
	calculateItemPrice,
	calculatePrice,
	formatPrice,
	getItemTagTextColor,
	getServiceName,
} from "../../../helpers/sampleHelper";
import { Divider } from "@mui/material";

interface Props {
	item: FrontendOrderItem;
	user: FrontendUserInfo | undefined;
	goToViewItemDetails: () => void;
	currency: string;

	deleteOrder: () => void;
}

export default function ItemRow(props: Props) {
	const { t: translation } = useTranslation();

	const { item, goToViewItemDetails, currency, user, deleteOrder } = props;

	const [tagText, tagTextColor, tagBackgroundColor] = getItemTagTextColor(
		item,
		translation
	);

	const itemRow: React.ReactNode = (
		<div
			key={item.orderItemId}
			className="item-list-view-item-row typography-body-01"
			onClick={() => {
				goToViewItemDetails();
			}}
		>
			<div
				style={{
					backgroundColor: tagBackgroundColor,
					color: tagTextColor,
					margin: "16px 0 0 24px",
				}}
				className="typography-caption item-tag"
			>
				{tagText}
			</div>
			<div className="item-list-view-row">
				<div className="order-list-view-row-item">
					{item.product.productName}
				</div>
				<div className="order-list-view-row-item">
					{formatPrice(item.product.unitPrice, currency)}
				</div>
				<div className="order-list-view-row-item order-list-view-sample-count-row-item">
					{item.product.quantity}
				</div>
				<div className="order-list-view-row-item order-list-view-sample-count-row-item">
					{formatPrice(
						calculatePrice(item.product.unitPrice, item.product.quantity),
						currency
					)}
				</div>
				<div className="order-list-view-row-item order-list-view-sample-count-row-item"></div>
				<div className="order-list-view-row-item order-list-view-sample-count-row-item"></div>
			</div>
			{item.service && (
				<>
					<Divider
						sx={{
							borderStyle: "dashed",
							borderColor: NeutralColor.NEUTRAL_GREY_50,
						}}
					></Divider>
					<div className="item-list-view-row">
						<div className="order-list-view-row-item">
							{getServiceName(item.service, translation)}
						</div>
						<div className="order-list-view-row-item">
							{formatPrice(item.service.unitPrice, currency)}
						</div>
						<div className="order-list-view-row-item order-list-view-sample-count-row-item">
							{item.service.quantity}
						</div>
						<div className="order-list-view-row-item order-list-view-sample-count-row-item">
							{formatPrice(
								calculatePrice(item.service.unitPrice, item.service.quantity),
								currency
							)}
						</div>
						<div className="order-list-view-row-item order-list-view-sample-count-row-item"></div>
						<div className="order-list-view-row-item order-list-view-sample-count-row-item"></div>
					</div>
				</>
			)}

			{/* <Restricted to={Permission.CLIENT_INFO}>
				<div className="order-list-view-row-item">
					{order.clientCompanyName}
					<div
						className="typography-caption"
						style={{
							display: "flex",
							gap: "5px",
							flexWrap: "wrap",
							color: NeutralColor.NEUTRAL_GREY_500,
						}}
					>
						<div style={{ display: "flex", gap: "3px", alignItems: "end" }}>
							<UserIcon
								size={20}
								strokeColor={NeutralColor.NEUTRAL_GREY_500}
								strokeWidth={1.5}
							/>
							{order.orderedBy}
						</div>
					</div>
				</div>
			</Restricted>

			<div className="order-list-view-row-item">
				<div
					className="typography-body-02 admin-order-status-box admin-status-box-small"
					style={{
						backgroundColor: statusColor.backgroundColor,
						border: `1px solid ${statusColor.borderColor}`,
						color: statusColor.textColor,
					}}
				>
					{statusString}
				</div>
			</div>
			{/* <div className="order-list-view-row-item">
				<div style={{ display: "flex", justifyContent: "center", gap: "5px" }}>
					{roleMeetsRequirement(user?.role as UserType, UserType.ADMIN) && (
						<div
							id={`delete-order=${order.shortId}`}
							style={{ cursor: "pointer" }}
							onClick={(e) => {
								e.stopPropagation();
								deleteOrder();
							}}
						>
							<DeleteIcon></DeleteIcon>
						</div>
					)}
				</div>
			</div> */}
		</div>
	);

	return itemRow;
}
